import { updateCredentialsToFirestore } from '@/utils/misc'

/**
 * @description Do auth for economic. Get token from params & save it in firestore as Grant Token
 * @param {Object} params
 * @param {string} params.appSlug
 * @param {Object} params.params
 * @returns {Promise<void>}
 */
export default async ({ appSlug, params }) => {
  const object = { 'Grant Token': params.token }
  await updateCredentialsToFirestore(appSlug, object)
}
